<template>
	<div class="canteen">

        <footer style="text-align: center;line-height: 10px;padding-top: 86vh;">
            <van-button type="danger" size="small" @click="go1()" style="width: 90px;">菜单评选</van-button>
            <van-button type="danger" size="small" @click="go2()" style="width: 90px;margin-left: 30px;">物资评选</van-button>
            <van-button type="danger" size="small" @click="go3()" style="width: 90px;margin-left: 30px;">满意度调查</van-button>
        </footer>

    </div>
</template>

<script>
	export default{
        methods: {
            go1() {
                this.$router.push('./shitang1')
            },
            go2() {
                this.$router.push('./shitang2')
            },
            go3() {
                this.$router.push('./stpf')
            },
        }
    }
</script>

<style scoped="cabteeb" lang='less'>
    .canteen {
        background-image: url(../assets/shitang.png);
        background-size: cover; 
        background-position: center; 
        min-height: 100vh; 
    }
   
</style>